<template>
  <BaseInputSkeleton v-bind="props">
    <template #input>
      <PInputSkeleton :size="props.size" />
    </template>
  </BaseInputSkeleton>
</template>

<script setup lang="ts">
import type { BaseInputSkeletonProps } from "@/molecules/baseInput.ts";

import PInputSkeleton from "@/atoms/PInputSkeleton.vue";
import BaseInputSkeleton from "@/molecules/BaseInputSkeleton.vue";

/* Can be used for all basic input molecules with the same layout and some organisms
 * autocomplete
 * datepicker
 * email
 * number input
 * password
 * select
 * text input
 * tree select
 * SZipcodeSegmented
 */
const props = withDefaults(defineProps<BaseInputSkeletonProps>(), {
  size: "md",
});
</script>
